import React from 'react';
import './App.css';
import { MuiThemeProvider } from '@material-ui/core';
import { theme, getHashParams, getCurrentUser } from './utils';
import { MainContext } from './context';
import { RootRouter } from './components/Router';

export function App() {
  const [filterType, setFilterType] = React.useState('');
  const [accessToken, setAccessToken] = React.useState(null);
  const [currentUser, setCurrentUser] = React.useState(null);
  const params = getHashParams();

  //Set token
  React.useEffect(() => {
    setUpAccessToken();
  }, []);

  const setUpAccessToken = () => {
    if (params.access_token === undefined) {
      let accessTokenInStorage = localStorage.getItem('accessToken');

      if (accessTokenInStorage !== null) {
        let parsedAccessToken = JSON.parse(localStorage.getItem('accessToken')!);

        //Deal with expiration
        if (new Date().getSeconds() < parsedAccessToken.expiresAt) {
          setAccessToken(parsedAccessToken.accessToken);

          getCurrentUser(parsedAccessToken.accessToken)
            .then((userObject: any) => {
              setCurrentUser(userObject);
            })
            .catch((err: any) => {
              console.log(err);
              setAccessToken(null);
            });
        } else setAccessToken(null);
      }
    }

    if (params.access_token !== undefined) {
      let tokenInfo = {
        accessToken: params.access_token,
        expiresAt: new Date().getSeconds() + params.expires_in
      };

      localStorage.setItem('accessToken', JSON.stringify(tokenInfo));
      setAccessToken(params.access_token);
      getCurrentUser(params.access_token)
        .then((userObject: any) => {
          setCurrentUser(userObject);
        })
        .catch((err: any) => {
          console.log(err);
          setAccessToken(null);
        });
    }
  };

  return (
    <MuiThemeProvider theme={theme}>
      <MainContext.Provider
        value={{
          accessToken: accessToken,
          filterType: filterType,
          setFilterType: setFilterType,
          currentUser: currentUser,
          setUpAccessToken: setUpAccessToken,
          setCurrentUser: setCurrentUser
        }}>
        <RootRouter />
      </MainContext.Provider>
    </MuiThemeProvider>
  );
}
